import http from '@/utils/http';
import { DOWNLOAD_TIMEOUT } from '@intelligence/services/download';

import type { AxiosResponse } from 'axios';
import type { IBaseResponse } from '@intelligence/types/common';
import type {
  OverlapSteamDetailsRank,
  IMobileDetailsOverlapTrend,
  IMobileDetailsOverlapRanksFetchParams,
  IMobileDetailsOverlapTrendsFetchParams,
} from '@intelligence/pages/TopCharts/MobileGames/components/GamesDetails/Overlap/types';

import type { SteamGamesDetailsOverlapRanksFetchParams } from '@intelligence/pages/TopCharts/PCGames/components/GamesDetails/OverlapSteam/types';

// 查询Overlap Analysis-Steam Games宽表数据接口
export const overlapAnalysisTopchartSteamGamesRankList: (
  payload: any,
  config?: { [key: string]: any },
) => Promise<any> = (payload, config) => {
  return http({
    ...config,
    url: '/api/v1/intelligence_pc/search/steam_overlap',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

export const overlapAnalysisTopchartMobileInsideRankList: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/pcTopChartCrossAppUsagesRankListDetail',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

export const fetchOverlapRanks = (
  params: IMobileOverlapListFetchParams,
): IBaseResponse<IPaginationData<IMobileOverlap>, IMobileDetailsOverlapRanksFetchParams> => {
  return http({
    url: '/api/v1/intelligence_pc/detail/crossAppUsageTablev2',
    method: 'post',
    data: params,
    rawData: true,
  }) as IBaseResponse<any>;
};

export const fetchOverlapSteamGamesRanks = (
  params: SteamGamesDetailsOverlapRanksFetchParams,
): IBaseResponse<OverlapSteamDetailsRank[], SteamGamesDetailsOverlapRanksFetchParams> => {
  return http({
    url: '/api/v1/intelligence_pc/detail/steamOverlapGame',
    method: 'post',
    data: params,
    rawData: true,
  }) as IBaseResponse<any>;
};

export const fetchAmpereOverlapGamesRanks = (params: any): Promise<any> => {
  return http({
    url: '/api/v1/intelligence_pc/detail/ampereOverlapGame',
    method: 'post',
    data: params,
    rawData: true,
  }) as Promise<any>;
};

export const fetchAmpereOverlapGameFilters = (params: {
  combined_id: string;
}): Promise<any> => {
  return http({
    url: '/api/v1/intelligence_pc/detail/ampereOverlapGame/filters',
    method: 'post',
    data: params,
    rawData: true,
  }) as Promise<any>;
};

export const fetchOverlapTrends = (
  params: IMobileDetailsOverlapTrendsFetchParams,
): IBaseResponse<{ trends: IMobileDetailsOverlapTrend[] }, IMobileDetailsOverlapTrendsFetchParams> => {
  return http({
    url: '/api/v1/intelligence_pc/detail/crossAppUsageTrendsv2',
    method: 'post',
    data: params,
    rawData: true,
  }) as IBaseResponse<any>;
};

export const downloadOverlapTopMobile = (params: any): Promise<AxiosResponse> => {
  return http({
    url: '/api/v1/intelligence_pc/pcTopChartCrossAppUsagesRankExcel',
    method: 'post',
    data: params,
    timeout: DOWNLOAD_TIMEOUT,
    original: true,
    // rawData: true,
    httpResponses: true,
    responseType: 'arraybuffer',
  }) as Promise<AxiosResponse>;
};

export const getSteamOverlapGameSummaryDatas: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/detail/steamOverlapGame/summary',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

export const getSteamOverlapRegionCountryLevelConfig: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/detail/steamOverlapGame/regionLevel',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};
